export default "__VITE_ASSET__C9lhF$Hz__"